import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import blogs from '../blogs';
import './Blog.css';

export default function Blog() {
  const [category, setCategory] = useState('All');
  const navigate = useNavigate();

  const categories = ['All', ...new Set(blogs.map((b) => b.category))];
  const tags = [...new Set(blogs.flatMap((b) => b.tags))];
  const filtered = category === 'All' ? blogs : blogs.filter((b) => b.category === category);
  const [featured, ...rest] = filtered;

  return (
    <div className="blog-page">
      <section className="blog-hero">
        <span className="blog-kicker">Articles</span>
      </section>

      <div className="blog-filters">
        {categories.map((c) => (
          <button key={c} className={c === category ? 'active' : ''} onClick={() => setCategory(c)}>
            {c}
          </button>
        ))}
      </div>

      {featured && (
        <Link to={`/blog/${featured.slug}`} className="blog-featured" style={{ textDecoration: 'none', color: 'inherit' }}>
          <div className={`blog-featured-visual${featured.image ? ' has-image' : ''}`}>
            {featured.image && <img src={featured.image} alt={featured.title} />}
          </div>
          <div className="blog-featured-content">
            <span className="badge">FEATURED · {featured.category.toUpperCase()}</span>
            <h2>{featured.title}</h2>
            <p>{featured.excerpt}</p>
            <div className="meta">
              <span>{featured.date}</span>·<span>{featured.readTime}</span>
            </div>
          </div>
        </Link>
      )}

      <div className="blog-layout">
        <div className="blog-grid">
          {rest.map((post) => (
            <div key={post.slug} className="blog-card" onClick={() => navigate(`/blog/${post.slug}`)}>
              <div className="blog-card-top">
                <span className="cat">{post.category}</span>
                <span>{post.readTime}</span>
              </div>
              <h3>{post.title}</h3>
              <p>{post.excerpt}</p>
              <div className="meta">
                <span>{post.author}</span>·<span>{post.date}</span>
              </div>
            </div>
          ))}
          {rest.length === 0 && (
            <div className="blog-card" style={{ cursor: 'default' }}>
              <h3>More articles coming soon</h3>
              <p>We are writing up more of our research. Check back shortly.</p>
            </div>
          )}
        </div>

        <aside className="blog-sidebar">
          <div className="sidebar-box">
            <h4 style={{ margin: 0 }}>Topics</h4>
            <div className="tags">
              {tags.map((t) => <span key={t}>{t}</span>)}
            </div>
          </div>
          <div className="sidebar-box dark">
            <h4 style={{ margin: 0 }}>Building with AI?</h4>
            <p style={{ fontSize: 14, opacity: 0.8 }}>Talk to us about agents, vision and LLM products.</p>
            <button onClick={() => (window.location.href = 'mailto:contact@silwren.com')}>Connect to Us</button>
          </div>
        </aside>
      </div>
    </div>
  );
}
